import { AppSessionActionTypes } from 'a/actions/appSessionActions';
import {
  PRODUCT_READING,
  PRODUCT_LECTURA,
  SELECTED_PRODUCT_KEY,
  PRODUCT_NOT_YET_SELECTED,
  USAGE_TAGS,
} from 'root/lib/constants';
import { SEARCHLIGHT_EVENT_TYPE } from 'root/lib/SearchlightDispatcher';
import { SEARCHLIGHT_ACTION_TYPE } from 'a/actions/searchlightActionCreators';

const initState = {
  hasInitialHubLoaded: false,
  hasUserInteracted: false, // if user has interacted with the app yet which is necessary to know for ios audio
  lastCallTime: Date.now(), // set as time when app loads
  searchlight: {
    roundSessionId: null,
    roundStartTimestamp: null,
    level: null, // include level in all searchlight events when available
  },
  sendingSearchlight: false, // default to false - otherwise store details in object
  product: sessionStorage.getItem(SELECTED_PRODUCT_KEY) || PRODUCT_NOT_YET_SELECTED,
  showGamePrototypes: false,
  usageTags: { // for field specific options, see USAGE_TAGS const
    [USAGE_TAGS.PROGRAM_USE.prefix]: USAGE_TAGS.PROGRAM_USE.value,
    [USAGE_TAGS.SUITE.prefix]: USAGE_TAGS.SUITE.value,
    [USAGE_TAGS.APP.prefix]: null,
    [USAGE_TAGS.PROGRAM.prefix]: null,
    [USAGE_TAGS.LANGUAGE.prefix]: null,
    [USAGE_TAGS.GRADE.prefix]: null,
    [USAGE_TAGS.SEASON.prefix]: null,
    [USAGE_TAGS.LOCATION.prefix]: null,
    [USAGE_TAGS.ASSESSMENT.prefix]: null,
    [USAGE_TAGS.GAME_MODE.prefix]: null,
    [USAGE_TAGS.QUEST_TYPE.prefix]: null,
    [USAGE_TAGS.SKILL_ID.prefix]: null,
    [USAGE_TAGS.GAME_PART.prefix]: null,
    [USAGE_TAGS.LEVEL.prefix]: null,
    [USAGE_TAGS.BOOK_TITLE.prefix]: null,
    [USAGE_TAGS.CAPTIONS.prefix]: null,
  },
};

const appSessionReducer = (state = initState, { type, payload = {} }) => {
  switch (type) {
    case AppSessionActionTypes.FIRST_USER_INTERACTION:
      return {
        ...state,
        hasUserInteracted: payload,
      };

    case SEARCHLIGHT_ACTION_TYPE.SEARCHLIGHT_DISPATCH_EVENT:
      if (payload?.application?.eventType === SEARCHLIGHT_EVENT_TYPE.MULTIPLE_SESSIONS) {
        return {
          ...state,
          sendingSearchlight: {
            event: payload.application.eventType,
            details: payload.application.details,
          },
        };
      }
      return state;

    case AppSessionActionTypes.RESET_SESSION_TIMER:
      return {
        ...state,
        lastCallTime: Date.now(), // store the time of the last call in milliseconds
        sendingSearchlight: false,
      };

    case AppSessionActionTypes.SET_INITIAL_HUB_LOADED:
      return {
        ...state,
        hasInitialHubLoaded: true,
      };

    case SEARCHLIGHT_ACTION_TYPE.SET_SEARCHLIGHT_DATA:
      return {
        ...state,
        searchlight: {
          ...state.searchlight,
          ...payload,
        },
      };

    case SEARCHLIGHT_ACTION_TYPE.CLEAR_SEARCHLIGHT_DATA:
      return {
        ...state,
        searchlight: {
          ...initState.searchlight,
        },
      };

    case AppSessionActionTypes.SET_PRODUCT:
      return {
        ...state,
        product: [PRODUCT_READING, PRODUCT_LECTURA].includes(payload.product) ? payload.product : state.product,
      };

    case AppSessionActionTypes.UPDATE_USAGE_TAGS:
      return {
        ...state,
        usageTags: {
          ...state.usageTags,
          ...payload,
        },
      };

    case AppSessionActionTypes.SET_SHOW_GAME_PROTOTYPES:
      return {
        ...state,
        showGamePrototypes: payload,
      };

    default:
      return state;
  }
};

export default appSessionReducer;
